import SecuredLayout from "../components/SecuredLayout";
import Dashboard from "../pages/Dashboard";
import UserRegistration from "../pages/Admin/UserRegistration";
// import Customers from "../pages/Admin/Customers";
import OutScan from "../pages/Admin/OutScan";
import InScan from "../pages/Admin/InScan";
import ListInScanByDate from "../pages/Admin/ListInScanByDate";
import ListOutScanByDate from "../pages/Admin/ListOutScanByDate";
import ListManifestInScanByDate from "../pages/Admin/ListManifestInScanByDate";
import ListManifestOutScanByDate from "../pages/Admin/ListManifestOutScanByDate";
import ServiceArea from "../pages/Admin/ServiceArea";
import AwbAllotment from "../pages/Admin/AwbAllotment";
import ConsignmentBooking from "../pages/Admin/ConsignmentBooking";
import Missing from "../pages/Missing";
import Unauthorized from "../pages/Unauthorized";
import Home from "../pages/Home";
import Login from "../pages/Login";
import PersistLogin from "../components/PersistLogin";
import ManifestCreation from "../pages/Admin/ManifestCreation";
import UserProfile from "../pages/Admin/UserProfile";
import ListUsers from "../pages/Admin/ListUsers";
import ListUsersSuperAdmin from "../pages/Admin/ListUsersSuperAdmin";

import ListFranchises from "../pages/Admin/ListFranchises";
import CreateFranchise from "../pages/Admin/CreateFranchise";
import ListEmployees from "../pages/Admin/ListEmployees";
import CreateEmployee from "../pages/Admin/CreateEmployee";
import MultiStepForm from "../pages/Admin/MultiStepForm";
import ManifestDetails from "../pages/Admin/ManifestDetails";
import GetEmployee from "../pages/Admin/GetEmployee";
import GetManifestByDate from "../pages/Admin/GetManifestByDate";
import UpdateManifest from '../pages/Admin/UpdateManifest';
import UpdateManifestCreation from '../pages/Admin/UpdateManifestCreation';
import UpdateEmployee from '../pages/Admin/UpdateEmployee';
import GetBooking from "../pages/Admin/GetBooking";
import GetBookConsignmentByDate from "../pages/Admin/GetBookConsignmentByDate";
import GetFranchise from '../pages/Admin/GetFranchise';
import UpdateFranchise from "../pages/Admin/UpdateFranchise";
import ManifestInScan from '../pages/Admin/ManifestInScan';
import ManifestOutScan from '../pages/Admin/ManifestOutScan';
import FranchiseAdminRegistration from "../pages/Admin/FranchiseAdminRegistration";
import UpdateConsignment from "../pages/Admin/UpdateConsignment";
import CreateCustomer from "../pages/Admin/CreateCustomer";
import ListCustomers from "../pages/Admin/ListCustomers";
import UpdateCustomer from "../pages/Admin/UpdateCustomer";
import Booking from "../pages/Admin/Booking";
// import TopBar from "../pages/Admin/TopBar";

import CreateFranchiseRate from "../pages/Admin/CreateFranchiseRate";
import UpdateFranchiseRate from "../pages/Admin/UpdateFranchiseRate";
import CreateCustomerRate from "../pages/Admin/CreateCustomerRate";
import ListFranchiseRate from "../pages/Admin/ListFranchiseRate";
import ListCustomerRate from "../pages/Admin/ListCustomerRate";
import UpdateCustomerRate from "../pages/Admin/UpdateCustomerRate";
// import TestLoginPage from "../pages/Admin/TestLoginPage";



const MyRoutes = [
  {
    path: "/",
    title: "Home",
    element: <Home />,
    errorElement: <Missing />,
  },
  {
    path: "login",
    element: <Login />,
    title: "Login",
  },
  {
    path: "unauthorized",
    title: "",
    element: <Unauthorized />,
  },
  {
    // secured routes
    element: <PersistLogin />,
    secured: true,
    children: [
      {
        path: "/",
        element: <SecuredLayout />,
        //   secured: true,
        children: [
          {
            index: true,
            path: "/dashboard",
            title: "Dashboard",
            //    secured: true,
            element: <Dashboard />,
            roles: ["SysAdmin", "Admin", "User"]
          },
          // {
          //   group: "Administration",
          //   path: "createfranchise",
          //   //      secured: true,
          //   title: "Create Franchise",
          //   element: <CreateFranchise />,
          //   roles: ["SysAdmin", "Admin"]
          // },
          {
            group: "Administration",
            path: "createfranchise",
            title: "Create Franchise",
            element: <CreateFranchise />,
            excluded_business_types: ["CC"],
            roles: ["SysAdmin", "Admin"],

          },
          {
            group: "Administration",
            path: "FranchiseAdminRegistration",
            title: "Create Admin for Franchise",
            //     secured: true,
            element: <FranchiseAdminRegistration />,
            roles: ["SysAdmin"]
          },
          {
            group: "Administration",
            path: "create/franchise_rate",
            //     secured: true,
            title: "Create Franchise Rate",
            element: <CreateFranchiseRate />,
            roles: ["SysAdmin"]
          },
          {
            group: "Administration",
            path: "GetEmployee/:employeeId",
            //     secured: true,
            // title: "Get Employee",
            element: <GetEmployee />,
            roles: ["Admin", "User"]
          },
          {
            group: "Administration",
            path: "UpdateEmployee/:employeeId",
            element: <UpdateEmployee />,
            roles: ["Admin", "User"]
          },

          {
            group: "Administration",
            path: "servicearea",
            title: "Service Areas",
            //     secured: true,
            element: <ServiceArea />,
            roles: ["SysAdmin"]
          },
          {
            group: "Administration",
            path: "AwbAllotment",
            title: "Awb Allotment",
            //     secured: true,
            element: <AwbAllotment />,
            roles: ["SysAdmin"]
          },
          {
            group: "Consignments",
            path: "inscan",
            title: "Scan",
            //    secured: true,
            element: <InScan />,
            roles: ["Admin", "User"]
          },

          {
            group: "Consignments",
            path: "outscan",
            // title: "Out-scan Entry",
            //    secured: true,
            element: <OutScan />,
            roles: ["Admin", "User"]
          },
          {
            group: "Consignments",
            path: "listInScanByDate",
            // title: "Scan List",
            //    secured: true,
            element: <ListInScanByDate />,
            roles: ["Admin", "User"]
          },
          {
            group: "Consignments",
            path: "listOutScanByDate",
            // title: "lOut-scan Entry",
            //    secured: true,
            element: <ListOutScanByDate />,
            roles: ["Admin", "User"]
          },
          {
            group: "Consignments",
            path: "ListManifestInScanByDate",
            // title: "Manifest scan List",
            //    secured: true,
            element: <ListManifestInScanByDate />,
            roles: ["Admin", "User"]
          },
          {
            group: "Consignments",
            path: "ListManifestOutScanByDate",
            // title: "lOut-scan Entry",
            //    secured: true,
            element: <ListManifestOutScanByDate />,
            roles: ["Admin", "User"]
          },
          {
            group: "Administration",
            path: "userprofile",
            title: "My Profile",
            //   secured: true,
            element: <UserProfile />,
            roles: ["Admin", "User"]
          },

          {
            group: "Administration",
            path: "ListUsers",
            // title: "List Users",
            //    secured: true,
            element: <ListUsers />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "ListUsersSuperAdmin",
            title: "List Users",
            //    secured: true,
            element: <ListUsersSuperAdmin />,
            roles: ["SysAdmin"]
          },
          // {
          //   group: "Consignments",
          //   path: "consignmentbooking",
          //   title: "Cons. Booking",
          //   //    secured: true,
          //   element: <ConsignmentBooking />,
          //   roles: ["SysAdmin", "Admin", "User"]
          // },
          {
            group: "Administration",
            path: "registeruser",
            title: "Register User",
            //     secured: true,
            element: <UserRegistration />,
            roles: ["Admin"]
          },
          //   {
          //     group: "Administration",
          //     path: "customers",
          //     title: "Customers",
          // //    secured: true,
          //     element: <Customers />,
          //     roles : ["Admin","User"]
          //   },

          {
            group: "Consignments",
            path: "manifestcreation",
            title: "Manifest Creation",
            //    secured: true,
            element: <ManifestCreation />,
            roles: ["Admin"]
          },
          {
            group: "Consignments",
            path: "ManifestInScan",
            secured: true,
            title: "Manifest Scan",
            element: < ManifestInScan />,
            roles: ["Admin"]
          },
          {
            group: "Consignments",
            path: "ManifestOutScan",
            secured: true,
            // title: "Manifest Out Scan",
            element: < ManifestOutScan />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "listfranchises",
            //      secured: true,
            // title: "List Franchises",
            element: <ListFranchises />,
            // roles: ["SysAdmin"]
            roles: ["SysAdmin", "Admin"],

          },

          {
            group: "Administration",
            path: "listemployees",
            // secured: true,
            // title: "List Employees",
            element: <ListEmployees />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "createemployee",
            //     secured: true,
            title: "Create Employee",
            element: <CreateEmployee />,
            roles: ["Admin"]
          },

          {
            group: "Consignments",
            path: "GetManifestByDate",
            //     secured: true,
            // title: "Manifest By Date",
            element: <GetManifestByDate />,
            roles: ["Admin"]
          },

          {
            index: true,
            path: "/UpdateManifestCreation/:manifestNumber",
            secured: true,
            element: <UpdateManifestCreation />,
          },
          {
            group: "Consignments",
            path: "ManifestDetails/:manifestNumber",
            //     secured: true,
            // title: "Manifest Details",
            element: <ManifestDetails />,
            roles: ["Admin"]
          },

          {

            index: true,
            path: "/GetBooking/:bookingId",
            secured: true,
            element: <GetBooking />,
          },
          {
            group: "Consignments",
            index: true,
            path: "/GetBookConsignmentByDate",
            title: "List Cons. By Date",
            secured: true,
            element: <GetBookConsignmentByDate />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "GetFranchise/:franchiseId",
            secured: true,
            // title: "Get Franchise",
            element: < GetFranchise />,
            roles: ["SysAdmin", "Admin"]
          },
          {
            group: "Administration",
            path: "UpdateFranchise/:franchiseId",
            //     secured: true,
            element: <UpdateFranchise />,
            roles: ["SysAdmin", "Admin"]
          },

          {
            group: "Consignments",
            path: "UpdateConsignment/:bookingId",
            //     secured: true,
            // title: "UpdateConsignment",
            element: <UpdateConsignment />,
            roles: ["Admin"]
          },

          {
            group: "Administration",
            path: "CreateCustomer",
            //     secured: true,
            title: "Create Direct Customer",
            element: <CreateCustomer />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            path: "ListCustomers",
            //     secured: true,
            // title: "List Customers",
            element: <ListCustomers />,
            roles: ["Admin"]
          },
          {
            // group: "Administration",
            path: "UpdateCustomer/:customerId",
            //     secured: true,
            // title: "Update Customer",
            element: <UpdateCustomer />,
            roles: ["Admin"]
          },
          {
            group: "Consignments",
            path: "booking",
            //     secured: true,
            title: "Booking",
            element: <Booking />,
            // roles: ["SysAdmin", "Admin", "User"]
            roles: ["Admin", "User"]
          },



          {
            group: "Administration",
            path: "list/franchise_rate",
            //     secured: true,
            // title: "List franchise rate",
            element: <ListFranchiseRate />,
            roles: ["SysAdmin"]
          },
          {
            group: "Administration",
            // path: "update/franchise_rate",
            path: "update/franchise_rate/:rateId",
            //     secured: true,
            // title: "Update Franchise Rate",
            element: <UpdateFranchiseRate />,
            roles: ["SysAdmin"]
          },
          {
            group: "Administration",
            path: "create/customer_rate",
            //     secured: true,
            title: "Create Customer Rate",
            element: <CreateCustomerRate />,
            roles: ["Admin"]
          },
          {
            group: "Administration",
            // path: "update/franchise_rate",
            path: "list/customer_rate",
            //     secured: true,
            // title: "Update Franchise Rate",
            element: <ListCustomerRate />,
            roles: ["Admin"]
          },

          {
            group: "Administration",
            path: "update/customer_rate/:rateId",
            //     secured: true,
            // title: "Update Franchise Rate",
            element: <UpdateCustomerRate />,
            roles: ["Admin"]
          },

          // {
          //   group: "Administration",
          //   path: "TestLoginPage",
          //   //     secured: true,
          //   // title: "Update Franchise Rate",
          //   element: <TestLoginPage />,
          //   roles: ["Admin"]
          // },

        ],
      },
    ],
  },
];

export default MyRoutes;
